.image {
  display: inline-block;
  margin-bottom: 12px;
}
